/* eslint-disable max-len */
import React, { useContext } from 'react';
import { TimeWheelIconTrigger } from './TimeWheelIconTrigger.js';
import { TimeWheelWrapper } from './TimeWheelWrapper.js';
import { TimeWheelContext } from './TimeWheelContext.js';
import { useConfigTimePickerCTX } from './useConfigTimePickerCTX.js';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';

// the Context is Reused in CalendarWithTimeWheel
export const WrappedTimeWheelContext = ({ children }: { children: JSX.Element }) => {
  const ctx = useConfigTimePickerCTX();
  return <TimeWheelContext.Provider value={ctx}>{children}</TimeWheelContext.Provider>;
};

const TimeWheelContent = () => {
  const { showTimePicker, handleMenuWrapperKeyDown } = useContext(TimeWheelContext);
  const { isControllerOnly } = useContext(ControlledDateTimePickerContext);

  return (
    <>
      {isControllerOnly ? null : <TimeWheelIconTrigger />}
      {isControllerOnly || showTimePicker ? (
        <>
          {/* The <div> element is catching the "Escape" key to close the calendar, there is no valid aria role for this */}
          {/* https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md#case-the-event-handler-is-only-being-used-to-capture-bubbled-events */}
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div onKeyDown={handleMenuWrapperKeyDown}>
            <TimeWheelWrapper />
          </div>
        </>
      ) : null}
    </>
  );
};
// we wrap in context in a separate statement so we can use the useContext and be sure it's correctly initialized
export const TimeWheel = (): JSX.Element => (
  <WrappedTimeWheelContext>
    <TimeWheelContent />
  </WrappedTimeWheelContext>
);
